import React, { FC } from 'react';

import { useNavigate } from 'react-router-dom';

import { DEAL_NOT_STARTED } from 'constants/deals';
import { TypographyVariants } from 'constants/shared/typography';
import { ModalWindow } from 'shared-components';
import Typography from 'shared-components/Typography';

type Props = {
  isOpen: boolean;
  companyName?: string;

  onClose: VoidFunction;
};

const NoDealModal: FC<Props> = ({ isOpen, companyName, onClose }) => {
  const navigate = useNavigate();

  const redirection = () => {
    navigate('/');
    onClose;
  };

  return (
    <ModalWindow isOpen={isOpen} onClose={redirection}>
      <div className='flex flex-col items-center justify-center pb-4'>
        <Typography variant={TypographyVariants.SEMI_MEDIUM} className='text-center'>
          Thank you for registering your interest in the {companyName} share exchange.
        </Typography>
        <Typography variant={TypographyVariants.SEMI_MEDIUM} className='text-center'>
          {DEAL_NOT_STARTED}
        </Typography>
      </div>
    </ModalWindow>
  );
};

export default NoDealModal;
